import type { MouseEvent } from 'react';

/** Makes a whole table row open the link in it, not just the name.

    Only the name is a real link, so it stays the one keyboard stop and screen
    readers announce one link per row, not six. A click anywhere else on the
    row is forwarded to that link, which then routes like any other link.
    Clicks on a control inside the row, and clicks that end a text selection,
    are left alone. */
export function openRowLink(e: MouseEvent<HTMLTableRowElement>) {
  if ((e.target as HTMLElement).closest('a, button, input, select, label')) return;
  if (window.getSelection()?.toString()) return;
  e.currentTarget.querySelector<HTMLAnchorElement>('a[href]')?.click();
}
